import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("About ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Pricing ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_button = _resolveComponent("icon-button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleNav(true))),
      class: "flex text-gray-800 md:hidden ml-3 cursor-pointer"
    }, [
      _createVNode(_component_v_icon, { name: "nav" })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.isNavOpen
          ? 'flex absolute -left-8 pt-5 z-10 h-full top-0 bg-home p-6'
          : 'hidden'
      , "flex-col md:flex-row md:flex"])
    }, [
      _createVNode(_component_router_link, {
        to: "/home",
        class: _normalizeClass(["md:ml-auto link", { 'text-white mt-8': _ctx.isNavOpen }])
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ], undefined, true),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/home",
        class: _normalizeClass(["link", { 'text-white mt-8': _ctx.isNavOpen }])
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ], undefined, true),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/home",
        class: _normalizeClass(["link", { 'text-white mt-8': _ctx.isNavOpen }])
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ], undefined, true),
        _: 1
      }, 8, ["class"]),
      (_ctx.isNavOpen)
        ? (_openBlock(), _createBlock(_component_icon_button, {
            key: 0,
            name: "close",
            class: "absolute top-2 right-1 text-white",
            onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleNav(false)))
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}